import script from "./Download-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Download-big.vue?vue&type=script&setup=true&lang=js"

import "./Download-big.vue?vue&type=style&index=0&id=aa71fee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa71fee2"]])

export default __exports__